import Deal from "./Deal";

export default class DealInfo {
  constructor(info) {
    this.deals = DealInfo._createDeals(info?.items);
    this.totalPages = info?.page_info?.total_pages ?? 0;
    this.totalCount = info?.total_count ?? 0;

    Object.freeze(this);
  }

  hasDeals() {
    return Boolean(this.deals) && this.deals.length > 0;
  }

  static _createDeals(deals = []) {
    return deals?.map(deal => new Deal(deal)) ?? [];
  }
}
